var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor b2cargo-order-status" }, [
    _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Query Type")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("a-select", {
            staticClass: "classic-new-select",
            attrs: { placeholder: "Query Type", options: _vm.types },
            model: {
              value: _vm.clone.type,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "type", $$v)
              },
              expression: "clone.type",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Company Code")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: "Company Code",
              rows: 1,
            },
            model: {
              value: _vm.clone._companyCode,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "_companyCode", $$v)
              },
              expression: "clone._companyCode",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.clone.type === "billNo"
      ? _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
          _c("div", { staticClass: "inputTitle" }, [_vm._v("Bill No")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-editor-wrapper" },
            [
              _c("TiptapEditor", {
                attrs: {
                  "show-attributes": true,
                  "max-character-count": 64,
                  "show-emoji": false,
                  placeholder: "Bill No",
                  rows: 1,
                },
                model: {
                  value: _vm.clone._billNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "_billNo", $$v)
                  },
                  expression: "clone._billNo",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.type === "atf"
      ? _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
          _c("div", { staticClass: "inputTitle" }, [_vm._v("ATF Seri")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-editor-wrapper" },
            [
              _c("TiptapEditor", {
                attrs: {
                  "show-attributes": true,
                  "max-character-count": 64,
                  "show-emoji": false,
                  placeholder: "ATF Seri",
                  rows: 1,
                },
                model: {
                  value: _vm.clone._atfSeri,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "_atfSeri", $$v)
                  },
                  expression: "clone._atfSeri",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.type === "atf"
      ? _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
          _c("div", { staticClass: "inputTitle" }, [_vm._v("ATF No")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-editor-wrapper" },
            [
              _c("TiptapEditor", {
                attrs: {
                  "show-attributes": true,
                  "max-character-count": 64,
                  "show-emoji": false,
                  placeholder: "ATF No",
                  rows: 1,
                },
                model: {
                  value: _vm.clone._atfNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "_atfNo", $$v)
                  },
                  expression: "clone._atfNo",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.type === "systemNo"
      ? _c("div", { staticClass: "b2cargo-order-status-info-wrapper" }, [
          _c("div", { staticClass: "inputTitle" }, [_vm._v("System No")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-editor-wrapper" },
            [
              _c("TiptapEditor", {
                attrs: {
                  "show-attributes": true,
                  "max-character-count": 64,
                  "show-emoji": false,
                  placeholder: "System No",
                  rows: 1,
                },
                model: {
                  value: _vm.clone._systemNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "_systemNo", $$v)
                  },
                  expression: "clone._systemNo",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled"))),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "next-step-filled-items-wrapper" },
      _vm._l(_vm.nextStepFilledValue, function (attr) {
        return _c(
          "div",
          { key: attr, staticClass: "logos middle-section" },
          [
            _c("AttributeIconPreview", { attrs: { attribute: attr } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ml-2" },
              [_c("AttributeLabel", { attrs: { attribute: attr } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }